import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import * as auth from 'store/ducks/auth.duck';
import { SetLatestConfigurationChange } from 'store/ducks/configuration.duck';
import { exitLogAsUser } from 'app/crud/users.crud';
import { errorToast } from 'utils/toastUtils';

const ImpersonationBanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();

  const { user, impersonator } = useSelector(
    ({ auth }) => ({
      user: auth.user,
      impersonator: auth.impersonator,
    }),
    shallowEqual
  );

  if (!impersonator) {
    return null;
  }

  const exitImpersonation = () => {
    exitLogAsUser()
      .then((response) => {
        dispatch(auth.actions.exitLogas(response.data));
        dispatch(SetLatestConfigurationChange(Date.now()));
        navigate('/administration');
      })
      .catch((err) => {
        errorToast({ body: err.response?.data?.error, intl: intl });
      });
  };

  return (
    <div className="impersonation-banner">
      <span className="impersonation-banner-dot" />
      <span>
        <FormattedMessage
          id="ADMIN_USERS.IMPERSONATION_BANNER"
          values={{
            user: (
              <>
                {user?.first_name}{' '}
                <span className="impersonation-banner-email">
                  ({user?.email})
                </span>
              </>
            ),
          }}
        />
      </span>
      <button
        type="button"
        className="impersonation-banner-exit"
        onClick={exitImpersonation}
      >
        <FormattedMessage id="ADMIN_USERS.EXIT_IMPERSONATION" />
      </button>
    </div>
  );
};

export default ImpersonationBanner;
